import React, { useEffect, useRef, useState } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  FormInput,
  LoadingComponent,
  MoreOptions,
  PreviewCard,
} from "../../../components/Component";
import { downloadInvoiceAPI, exportInvoiceList, exportInvoiceListXLSX } from "./InvoiceTableData";
import InvoiceList from "./InvoiceList";
import { useHistory } from "react-router-dom";
import { openLinkInNewTab, toCapitalize } from "../../../utils/Functions";
import { EXPORT_TYPE, File_TYPE, InvoiceStatusOption } from "../../../utils/Utils";
import ActionButton from "../../../components/button/ActionButton";
import DateRangePicker from "../../../components/input/date-time/DateRangePicker";
import { ButtonGroup } from "reactstrap";
import { UserActionType, UserPermissionType, isAllowToAccess } from "../../../services/permission/permission";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import ExportButton from "../../../components/button/ExportButton";
import HospitalHomeCareDropDown from "../../../components/dropdowns/HospitalHomeCareDropDown";
const Invoice = () => {
  const history = useHistory();
  const location = useLocation();
  const data = location?.state?.data;
  const [status, setStatus] = useState({
    value: InvoiceStatusOption.pending,
  });
  const [activeButton, setActiveButton] = useState(0);
  const [searchText, setSearchText] = useState();
  const [carer, setCarer] = useState();
  const [client, setClient] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [clientType, setClientType] = useState();
  const [isSwitchOn, setSwitchOn] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const invoiceRef = useRef(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const isBackSent = location?.state?.isBackSent;
  const val = {
    ...InvoiceStatusOption,
  };
  const invoiceStatus = Object.values(val);
  useEffect(() => {
    if (isBackSent) {
      setActiveButton(2); // Set active button to index 2
      setStatus({
        value: invoiceStatus[2],
      }); // Set the status to the corresponding value at index 2
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBackSent]);
  useEffect(() => {
    if (location?.state?.isInvoiceListMove) {
      setStartDate(data?.startDate);
      setEndDate(data?.endDate);
      setActiveButton(invoiceStatus.findIndex((valueItem) => valueItem === InvoiceStatusOption.prepared));
      setStatus({
        value: InvoiceStatusOption.prepared,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.state?.isInvoiceListMove]);
  const handleNextPrev = (ev, isNext) => {
    ev.preventDefault();
    const currentDate = new Date(startDate);

    // Calculate the new start date and end date
    const daysToAdd = isNext ? 7 : -7;
    const newStartDate = new Date(currentDate.getTime() + daysToAdd * 24 * 60 * 60 * 1000);

    // Find the nearest Monday before or on the new start date
    const startDayOfWeek = newStartDate.getDay(); // 0 (Sunday) to 6 (Saturday)
    const daysToSubtract = startDayOfWeek === 0 ? 6 : startDayOfWeek - 1;
    newStartDate.setDate(newStartDate.getDate() - daysToSubtract);

    // Calculate the end date (Sunday of the same week)
    const newEndDate = new Date(newStartDate.getTime() + 6 * 24 * 60 * 60 * 1000);

    // Update the state with new start and end dates
    setStartDate(newStartDate.toISOString().slice(0, 10));
    setEndDate(newEndDate.toISOString().slice(0, 10));
  };
  const handleDateChange = (selectedDate) => {
    const currentDate = new Date(selectedDate);
    const currentDay = currentDate.getDay(); // 0 (Sunday) to 6 (Saturday)
    const daysToSubtract = currentDay === 0 ? 6 : currentDay - 2; // Adjust to previous Monday

    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() - daysToSubtract);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // End of the week (Sunday)

    setStartDate(startOfWeek.toISOString().slice(0, 10));
    setEndDate(endOfWeek.toISOString().slice(0, 10));
  };
  const exportFile = (fileType) => {
    if (File_TYPE?.pdf === fileType) {
      exportPDF();
    } else if (File_TYPE?.xlxs === fileType) {
      exportXLSX();
    } else if (File_TYPE?.all === fileType) {
      downloadAllInvoice();
    }
  };
  function downloadAllInvoice() {
    setLoadingExport(true);
    let params = {
      startDate: !isSwitchOn ? startDate : "",
      endDate: !isSwitchOn ? endDate : "",
      clientType: clientType?.value ?? null,
      status: status?.value ?? InvoiceStatusOption.pending,
      search: searchText,
    };
    downloadInvoiceAPI(params, (data, error) => {
      if (error === null && data?.downloadUrl) {
        openLinkInNewTab(data.downloadUrl, null, {
          download: true,
        });
      }
      setLoadingExport(false);
    });
  }
  function exportPDF() {
    if (!startDate || !endDate) return;
    setLoadingExport(true);
    let params = {
      startDate: !isSwitchOn ? startDate : "",
      endDate: !isSwitchOn ? endDate : "",
      clientId: client?.id,
      carerId: carer?.id,
      status: status?.value ?? InvoiceStatusOption.pending,
      search: searchText,
    };
    exportInvoiceList(params, (data, error) => {
      if (error === null) {
        openLinkInNewTab(data.fileUrl);
      }
      setLoadingExport(false);
    });
  }
  function exportXLSX() {
    if (!startDate || !endDate) return;
    setLoadingExport(true);
    let params = {
      startDate: !isSwitchOn ? startDate : "",
      endDate: !isSwitchOn ? endDate : "",
      clientId: client?.id,
      carerId: carer?.id,
      status: status?.value ?? InvoiceStatusOption.pending,
      search: searchText,
    };
    exportInvoiceListXLSX(params, (data, error) => {
      if (error === null) {
        openLinkInNewTab(data.fileUrl);
      }
      setLoadingExport(false);
    });
  }
  const handleDatePickerChange = (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };
  const handleButtonClick = (item) => {
    const newValue = item === "ALL" ? "" : item;
    setActiveButton(invoiceStatus.findIndex((valueItem) => valueItem === item));
    setStatus({
      value: newValue,
    });
  };
  const handleClearRows = () => {
    setSelectedRows([]);
  };
  const onHospitalTypeChange = (clientType) => {
    setClientType(clientType);
    // updateQueryParams({ clientType: clientType?.value });
  };
  const handleSwitchToggle = () => {
    setSwitchOn(!isSwitchOn);
    if (isSwitchOn) {
      setStartDate("");
      setEndDate("");
    }
  };
  const getTotalItem = (totalItem) => {
    setTotalItems(totalItem);
  };
  return (
    <React.Fragment>
      <Head title="Invoices" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="flex-wrap">
            <BlockHeadContent>
              <BlockTitle page>Invoices</BlockTitle>
              <BlockDes className="text-soft">
                <p>You have total {totalItems} invoices</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent className="ms-auto">
              <div className="toggle-wrap nk-block-tools-toggle">
                <div className="nk-block-tools d-flex flex-wrap justify-content-end">
                  <span className="p-1">
                    <FormInput
                      inputClass={"padding-important"}
                      isShowLabel={false}
                      value={searchText ?? ""}
                      placeholder="Invoice No, Client, ContactName"
                      onTextChange={(text) => setSearchText(text)}
                      baseClass="w-220px"
                    />
                  </span>
                  <span className="p-1">
                    <HospitalHomeCareDropDown
                      value={clientType}
                      placeholder={"Client Type"}
                      className="w-125px"
                      onSelect={(e) => {
                        onHospitalTypeChange(e);
                      }}
                    />
                  </span>
                  <span className="p-1">
                    <ButtonGroup>
                      {invoiceStatus?.map((item, index) => (
                        <Button
                          key={index}
                          className={`btn-dim btn-white border-right border
                             ${activeButton === invoiceStatus?.findIndex((valueItem) => valueItem === item) ? "bg-purple btn-lighter text-white" : "bg-white text-gray"}`}
                          onClick={() => handleButtonClick(item)}
                        >
                          {toCapitalize(item)}
                        </Button>
                      ))}
                    </ButtonGroup>
                  </span>
                  <span className="d-flex align-items-center p-1">
                    Week
                    <label className="switch ms-1 me-1">
                      <input type="checkbox" checked={isSwitchOn} onChange={handleSwitchToggle} />
                      <span className="slider round"></span>
                    </label>
                    ALL
                  </span>
                  {!isSwitchOn && (
                    <span className="p-1">
                      <DateRangePicker
                        onDateChange={handleDatePickerChange}
                        moveDate={
                          location?.state?.isInvoiceListMove
                            ? {
                                startDate,
                                endDate,
                              }
                            : undefined
                        }
                      />
                    </span>
                  )}
                  <span className="p-1">
                    <ActionButton
                      title="Add Invoice"
                      size="md"
                      onClick={() =>
                        history.push({
                          pathname: `${process.env.PUBLIC_URL}/add-invoice`,
                        })
                      }
                    />
                  </span>
                  {isAllowToAccess(UserPermissionType.invoice, UserActionType.export) && (
                    <span className="p-1">
                      <ExportButton
                        options={EXPORT_TYPE}
                        onChange={(fileType) => exportFile(fileType)}
                        hideOption={
                          status?.value === InvoiceStatusOption.pending ||
                          status?.value === InvoiceStatusOption.archived
                        }
                        isSwitchOn={isSwitchOn}
                      />
                    </span>
                  )}
                  {selectedRows?.length > 0 &&
                    (isAllowToAccess(UserPermissionType.invoice, UserActionType.prepare) ||
                      isAllowToAccess(UserPermissionType.invoice, UserActionType.sent)) && (
                      <span className="p-1">
                        <MoreOptions
                          className="text-bg-light"
                          options={[
                            {
                              icon: "file",
                              text: "Prepare Invoice",
                              action: () => {
                                invoiceRef.current?.sendPrepared();
                              },
                              hide:
                                activeButton !== 0 ||
                                !isAllowToAccess(UserPermissionType.invoice, UserActionType.prepare),
                            },
                            {
                              icon: "emails",
                              text: "Send Email",
                              action: () => {
                                invoiceRef.current?.sendEmail();
                              },
                              hide:
                                activeButton !== 1 || !isAllowToAccess(UserPermissionType.invoice, UserActionType.sent),
                            },
                            {
                              icon: "send",
                              text: "Resend Email",
                              action: () => {
                                invoiceRef.current?.reSendEmail();
                              },
                              hide:
                                activeButton === 0 ||
                                activeButton === 1 ||
                                !isAllowToAccess(UserPermissionType.invoice, UserActionType.sent),
                            },
                          ]}
                        />
                      </span>
                    )}
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewCard className={"bg-transparent invoice-list-table"}>
            <div className="ms-n4 me-n2 my-n2">
              <InvoiceList
                ref={invoiceRef}
                startDate={startDate}
                endDate={endDate}
                clientId={client?.id}
                carerId={carer?.id}
                status={status}
                clientType={clientType?.value}
                searchText={searchText}
                showAll={isSwitchOn}
                selectedRows={selectedRows}
                onRowSelectionChange={(rows) => setSelectedRows(rows)}
                handleClearRows={handleClearRows}
                getTotalItem={getTotalItem}
              />
            </div>
          </PreviewCard>
        </Block>
      </Content>
      <LoadingComponent isLoading={loadingExport} />
    </React.Fragment>
  );
};
export default Invoice;
